/* Starbound v17 homepage: cinematic opening, music, scroll reveals. Loaded once per page. */
(function(){
  if(window.__sbHome)return; window.__sbHome=true;
  var design=!!(window.Shopify&&Shopify.designMode);
  function showAll(root){(root||document).querySelectorAll('.sbh .reveal').forEach(function(e){e.classList.add('in');});}
  if(design){var i=document.getElementById('intro'); if(i)i.remove(); document.body.classList.remove('locked'); showAll();}
  document.addEventListener('shopify:section:load',function(e){showAll(e.target);});
  function start(){
  const intro=document.getElementById('intro');
  if(!intro){document.body.classList.remove('locked');document.querySelectorAll('.hero .reveal').forEach(el=>el.classList.add('in'));}
  const body=document.body;
  const audio=document.getElementById('ambient');
  const musicBtn=document.getElementById('musicBtn');
  if(!intro){wireRest();return;}
  const noMusic=!audio.getAttribute('src');   // no MP3 set in theme settings: play the opening silently, right away
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

  // floating gold dust
  const dust=intro.querySelector('.dust');
  for(let i=0;i<26;i++){const s=document.createElement('i');s.style.left=Math.random()*100+'%';s.style.top=(60+Math.random()*40)+'%';s.style.animationDelay=(Math.random()*9)+'s';s.style.animationDuration=(7+Math.random()*6)+'s';s.style.width=s.style.height=(2+Math.random()*3)+'px';dust.appendChild(s);}

  // gentle piano instrumental (assets/audio/starbound-piano.mp3)
  const hint=document.getElementById('introHint');
  let musicOn=false, fader=null, closed=false;
  audio.addEventListener('error',()=>{musicBtn.hidden=true;});
  try{audio.load();}catch(e){}
  function fadeTo(target,step,ms,done){clearInterval(fader);fader=setInterval(()=>{const v=audio.volume+step;if((step>0&&v>=target)||(step<0&&v<=target)){audio.volume=target;clearInterval(fader);if(done)done();}else audio.volume=v;},ms);}
  /* returns a promise: true = music is playing, false = the browser blocked it */
  function startMusic(){
    if(musicOn)return Promise.resolve(true);
    audio.volume=0;
    return audio.play().then(()=>{if(closed){audio.pause();return false;}musicOn=true;fadeTo(.5,.025,60);musicBtn.hidden=false;musicBtn.textContent='♪ Pause music';hint.classList.remove('show');return true;})
      .catch(()=>{musicOn=false;return false;});
  }
  function stopMusic(){musicOn=false;fadeTo(0,-.03,100,()=>audio.pause());musicBtn.textContent='♪ Play music';}
  musicBtn.addEventListener('click',()=>{if(musicOn)stopMusic();else startMusic().then(ok=>{if(ok)begin();});});

  let timers=[];
  function finish(){
    if(closed)return;closed=true;
    timers.forEach(clearTimeout);
    intro.classList.add('done');body.classList.remove('locked');
    try{sessionStorage.setItem('sb-intro','1');}catch(e){}
    if(musicOn)stopMusic();
    setTimeout(()=>intro.remove(),1600);
    revealAll();
  }
  document.getElementById('skipBtn').addEventListener('click',finish);
  document.getElementById('enterBtn').addEventListener('click',finish);

  let seen=false;try{seen=sessionStorage.getItem('sb-intro')==='1';}catch(e){}
  let began=false;
  function begin(){
    /* the sequence is timed to the music: it only starts once the piano is playing
       (or, if the visitor never allows sound, after the fallback below) */
    if(began)return;began=true;
    const t=(fn,ms)=>timers.push(setTimeout(fn,ms));
    hint.classList.remove('show');
    t(()=>intro.classList.add('s1'),150);      // envelope rises in
    t(()=>intro.classList.add('s2'),4550);     // seal lifts, flap opens
    t(()=>intro.classList.add('s3'),5950);     // letter emerges
    t(()=>intro.classList.add('s4'),8550);     // headline
    t(finish,13450);                           // auto-enter
  }
  if(seen||reduced){intro.remove();body.classList.remove('locked');}
  else{
    /* 1. Try to start the music immediately. Where the browser allows it, the
          envelope scene begins the instant the piano does — perfectly in sync.
       2. If the browser blocks sound before any interaction (Chrome/Safari on a
          first visit), the envelope waits on screen with a "tap anywhere" hint;
          the visitor's very first tap/click/key starts music + scene together.
       3. If nobody interacts for 8s, the scene plays on its own (silently) so the
          site is never stuck behind the opening. */
    intro.classList.add('s1');                 // envelope rests on screen while we wait
    const events=['pointerdown','keydown','touchstart','wheel'];
    const kick=(e)=>{
      if(began)return;
      if(e.target&&e.target.closest&&e.target.closest('#musicBtn'))return;   // button has its own handler
      startMusic().then(ok=>{if(ok)begin();});
    };
    const tryAuto=()=>startMusic().then(ok=>{
      if(ok){begin();return;}
      if(began)return;
      musicBtn.hidden=false;
      hint.classList.add('show');
      events.forEach(t=>addEventListener(t,kick,{capture:true,passive:true}));
    });
    if(noMusic){musicBtn.hidden=true;begin();}else{tryAuto();}
    audio.addEventListener('canplay',()=>{if(!musicOn&&!began)tryAuto();},{once:true});
    setTimeout(()=>{if(!began)begin();},8000);  // silent fallback
    audio.addEventListener('playing',()=>{if(!began)begin();});
  }

  function revealAll(){document.querySelectorAll('.hero .reveal').forEach(el=>el.classList.add('in'));}
  wireRest();
  function wireRest(){
  // scroll reveals
  const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
  if(intro&&(seen||reduced))revealAll();


  // personal note counter
  const ta=document.getElementById('noteText'),nc=document.getElementById('noteCount');
  if(ta)ta.addEventListener('input',()=>nc.textContent=ta.value.length);
  }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
